stopQueryInStore